import { render, staticRenderFns } from "./GymRouteSubLevel.vue?vue&type=template&id=5b7fe58a"
import script from "./GymRouteSubLevel.vue?vue&type=script&lang=js"
export * from "./GymRouteSubLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports